import { Link } from 'components/layout';

export const LinkToProject = ({ projectId, children }) => (
  <Link to={`/projects/${projectId}/profile`}>{children}</Link>
);
export const LinkToReportSubmission = ({ projectId, id, children }) => (
  <Link to={`/projects/${projectId}/report-submissions/${id}`}>{children}</Link>
);
